import React from 'react';

import { NavFooterDetail } from 'components/blocks/NavFooter';

const DetailScreen = (props) => {
  return (
    <div className="page-main">
      <NavFooterDetail />
    </div>
  );
};

export default DetailScreen;
